import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "input", "icon"];
  toggle(event) {
    event.preventDefault();
    const checkbox = this.inputTarget;
    checkbox.checked = !checkbox.checked;

    const textNode = this.iconTarget.nextSibling;
    if (textNode && textNode.nodeType === Node.TEXT_NODE) {
      textNode.textContent = checkbox.checked ? " Quitar" : " Agregar";
    } else {
      this.buttonTarget.insertBefore(
        document.createTextNode(checkbox.checked ? " Quitar" : " Agregar"),
        textNode
      );
    }

    this.buttonTarget.classList.toggle("primary", checkbox.checked);
    this.buttonTarget.classList.toggle("success", !checkbox.checked);
    this.iconTarget.classList.toggle("fa-minus", checkbox.checked);
    this.iconTarget.classList.toggle("fa-plus", !checkbox.checked);
  }
}
